import React, { useEffect } from "react";
import { View, Text, StyleSheet, TouchableOpacity } from "react-native";
//import FastImage from 'react-native-fast-image';
import { globalFontStyle, globalStyle } from "../../../assets";
import Colors from "../../../assets/Color/Colors";

const ClubsCard = ({ clubDetails }) => {
  return (
    <View style={globalStyle.cardContainer}>
      <View style={{ flexDirection: "row", alignItems: "center" }}>
        <View
          style={[
            styles.marketImgStyle,
            { backgroundColor: Colors.grey5, marginRight: 12 },
          ]}
        >
          <FastImage
            resizeMode={FastImage.resizeMode.contain}
            style={styles.marketImgStyle}
            source={{ uri: clubDetails?.image_url }}
          />
        </View>
        <Text
          style={[globalFontStyle.appFontSubTextBold, { color: Colors.black }]}
        >
          {" "}
          {clubDetails?.title}
        </Text>
      </View>

      <View
        style={{
          flexDirection: "row",
          justifyContent: "space-between",
          marginTop: 24,
        }}
      >
        <View>
          <Text style={[globalFontStyle.appSmall10, { marginBottom: 5 }]}>
            Total Club Members
          </Text>
          <Text style={[globalFontStyle.appFontBody, { color: Colors.black }]}>
            {clubDetails?.total_members}
          </Text>
        </View>
        <View>
          <Text style={[globalFontStyle.appSmall10, { marginBottom: 5 }]}>
            Total Active Markets
          </Text>
          <Text
            style={[
              globalFontStyle.appFontBody,
              { color: Colors.green, textAlign: "right" },
            ]}
          >
            {clubDetails?.active_markets}
          </Text>
        </View>
      </View>
    </View>
  );
};

export default ClubsCard;

const styles = StyleSheet.create({
  marketImgStyle: {
    width: 35,
    height: 35,
  },
});
